module.exports = __webpack_public_path__ + "img/thumb-abacus.58777879.jpg";